<template>
    <div v-if="body_show" class="he-review-box">
        <h2>我是<span>&nbsp;{{data.nickname}}&nbsp;</span>，请你根据对我的了解，帮我选出我的<span>&nbsp;5&nbsp;</span>项突出优势！</h2>
        <div class="label-list clearfix">
            <h3>思维能力</h3>
            <label  v-for="(item,index) in thinking_list" :key="index" :class="{on: evaluationList.indexOf(item.id)>=0}" >
                <input type="checkbox" :value="item.id" v-model="evaluationList" />{{item.title}}
            </label>
        </div>
        <div class="label-list clearfix">
            <h3>人际能力</h3>
            <label  v-for="(item,index) in interpersonal_list" :key="index" :class="{on: evaluationList.indexOf(item.id)>=0}"  >
                <input type="checkbox" :value="item.id" v-model="evaluationList" />{{item.title}}
            </label>
        </div>
        <div class="label-list clearfix">
            <h3>任务管理</h3>
            <label  v-for="(item,index) in task_list" :key="index" :class="{on: evaluationList.indexOf(item.id)>=0}"  >
                <input type="checkbox" :value="item.id" v-model="evaluationList" />{{item.title}}
            </label>
        </div>
        <div class="label-list clearfix">
            <h3>团队管理</h3>
            <label  v-for="(item,index) in team_list" :key="index" :class="{on: evaluationList.indexOf(item.id)>=0}"  >
                <input type="checkbox" :value="item.id" v-model="evaluationList" />{{item.title}}
            </label>
        </div>
        <a href="javaScript:;" @click="submintHandle" :class="['submitBtn',evaluationList.length==5?'on':'']">确定</a>
        <!-- 超过五个弹出 -->
        <van-popup v-model="evaluationShow" class="vanPop">
            啊哦，最多只能选<span>5</span>个突出优势，再思考一下吧！
        </van-popup>
    </div>
</template>

<script>
import { ability,abilitycommit } from "@/api/measurement";
import { shareCon } from "@/utils/wxconfig";
export default {
    data() {
      return {
        data: {},
        body_show: false,
        thinking_list:[],
        interpersonal_list:[],
        task_list:[],
        team_list:[],
        evaluationList:[],
        evaluationShow:false
      }
    },
    methods: {
        pullData() {
        ability({
            cid: this.$route.query.cid,
            uid:this.$route.query.uid
          })
          .then((data) => {
            this.body_show = true;
            document.title = data.headtitle;
            this.data = data;
            if(!data.list){
                return;
            }
            for(let i=0;i<data.list.length;i++){
                // 2是思维能力
                if(data.list[i].sid == 2){
                    let obj = {};
                    obj['id'] = data.list[i].id;
                    obj['sid'] = data.list[i].sid;
                    obj['title'] = data.list[i].title;
                    this.thinking_list.push(obj)
                }
                // // 3是人际能力
                if(data.list[i].sid == 3){
                    let obj = {};
                    obj['id'] = data.list[i].id;
                    obj['sid'] = data.list[i].sid;
                    obj['title'] = data.list[i].title;
                    this.interpersonal_list.push(obj)
                }
                // // 4是任务管理
                if(data.list[i].sid == 4){
                    let obj = {};
                    obj['id'] = data.list[i].id;
                    obj['sid'] = data.list[i].sid;
                    obj['title'] = data.list[i].title;
                    this.task_list.push(obj)
                }
                // // 5是团队管理
                if(data.list[i].sid == 5){
                    let obj = {};
                    obj['id'] = data.list[i].id;
                    obj['sid'] = data.list[i].sid;
                    obj['title'] = data.list[i].title;
                    this.team_list.push(obj)
                }
            }
        })
      },
    //   提交他评
        submintHandle(){
            if(this.evaluationList.length <5){
                return false;
            }
            // 声明一个类型数组sid
            let sidList = [];
            for(let i=0;i<this.data.list.length;i++){
                for(let k=0;k<this.evaluationList.length;k++){
                    if(this.evaluationList[k]==this.data.list[i].id){
                        sidList.push(this.data.list[i].sid);
                    }
                }
            }
            abilitycommit({
                cid: this.$route.query.cid,
                uid:this.$route.query.uid,
                aid:this.evaluationList,
                sid:sidList
                })
                .then((data) => {
                if(data.data.msg.indexOf('提交成功！') < 0){
                    this.$toast(data.data.msg);
                }else{
                    this.$router.push({
                        path:'/evaluation_share',
                        query:{
                            cid: this.$route.query.cid,
                            uid:this.$route.query.uid,
                        }
                    })
                }
            })
        }
    },
    watch:{
        evaluationList(newVal,oldVal){
            if(newVal.length>5){
                this.evaluationList = oldVal;
                this.evaluationShow = true;
            }
        }
    },
    created() {
      this.pullData();
      shareCon("measurement",this);
    }
}
</script>

<style lang="scss" scoped>
    .he-review-box{
        padding: 40px 30px 108px 30px;
        h2{
            color: #333;
            font-size: 34px;
            line-height: 48px;
            margin-bottom: 50px;
            span{
                color: #F57F17;
            }
        }
    }
    .label-list{
        h3{
            color: #333;
            font-size: 30px;
            padding: 0 28px 30px 28px;
        }
        label{
            border-radius:34px;
            display: block;
            padding: 0 30px;
            text-align: center;
            font-size: 30px;
            color: #EB5032;
            border: 2px solid #EB5032;
            height: 68px;
            line-height: 68px;
            float: left;
            margin-right: 30px;
            margin-bottom: 30px;
            input{
                width: 0;
                height: 0;
                font-size: 0;
                border: none;
            }
        }
        label.on{
            background-color: #EB5032;
            color: #fff;
        }
    }
    .submitBtn{
        line-height: 78px;
        position: fixed;
        bottom: 0;
        left: 0;
        background-color: #cccccc;
        font-size: 34px;
        color: #fff;
        text-align: center;
        width: 100%;
    }
    .submitBtn.on{
        background-color: #EB5032;
    }
    .vanPop{
        font-size: 34px;
        color: #000;
        line-height:48px;
        padding: 94px 48px;
        width: 480px;
        text-align: center;
        border-radius:8px;
        span{
            color:#F57F17;
        }
    }
</style>
